import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import ContentCard from "@/components/ContentCard";

export default function ContentRow({ name, items, tenantSlug, themeColor, kind = "mixed" }) {
  const scrollerRef = useRef(null);

  const variant = kind === "reel" ? "reel" : kind === "movie" || kind === "series" ? "poster" : "landscape";

  const scroll = (dir) => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * el.clientWidth * 0.85, behavior: "smooth" });
  };

  if (!items || items.length === 0) return null;

  return (
    <section className="px-6 md:px-10 py-4 group/row" data-testid={`content-row-${name.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-end justify-between mb-3">
        <h2 className="font-display font-bold text-lg md:text-xl tracking-tight">{name}</h2>
        <span className="text-[10px] uppercase tracking-[0.3em] text-white/30">{items.length} {items.length === 1 ? "title" : "titles"}</span>
      </div>
      <div className="relative">
        <button
          aria-label="Scroll left"
          onClick={() => scroll(-1)}
          className="hidden md:grid place-items-center absolute left-0 top-0 bottom-0 z-10 w-10 bg-black/70 hover:bg-black/90 opacity-0 group-hover/row:opacity-100 transition-opacity"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <div
          ref={scrollerRef}
          className="flex gap-3 overflow-x-auto pb-2 snap-x"
          style={{ scrollbarWidth: "thin" }}
        >
          {items.map((it) => (
            <div
              key={it.id}
              className={`snap-start ${variant === "poster" ? "w-[150px] md:w-[180px]" : variant === "reel" ? "w-[140px] md:w-[160px]" : "w-[260px] md:w-[320px]"}`}
            >
              <ContentCard
                item={it}
                tenantSlug={tenantSlug}
                variant={variant}
                themeColor={themeColor}
                showCreator={kind === "reel"}
              />
            </div>
          ))}
        </div>
        <button
          aria-label="Scroll right"
          onClick={() => scroll(1)}
          className="hidden md:grid place-items-center absolute right-0 top-0 bottom-0 z-10 w-10 bg-black/70 hover:bg-black/90 opacity-0 group-hover/row:opacity-100 transition-opacity"
        >
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
    </section>
  );
}
